import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import animatedIf from 'ember-animated/components/animated-if';
import not from 'ember-truth-helpers/helpers/not';
import or from 'ember-truth-helpers/helpers/or';
import BvAnimated from 'volta/components/bv-animated';
import classNames from 'volta/helpers/class-names';
import guid from 'volta/helpers/guid';
import orElse from 'volta/helpers/or-else';
import type { TOC } from '@ember/component/template-only';
interface BvCollapsibleSignature {
    Args: {
        expandOnPrint?: boolean;
        growDelay?: number;
        id?: string;
        open: boolean;
        overflowHidden?: boolean;
    };
    Blocks: {
        default: [BvCollapsibleSignature['Args']['open']];
    };
    Element: HTMLElement;
}
const BvCollapsibleComponent: TOC<BvCollapsibleSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <BvAnimated
    @contained={{true}}
    class={{classNames
      'bv-collapsible'
      (if @open 'bv-collapsible--open')
      (if @expandOnPrint 'bv-collapsible--expand-on-print')
      (if (orElse @overflowHidden true) 'u-overflow-hidden')
    }}
    id={{or @id (guid)}}
    aria-hidden={{not @open}}
    ...attributes
    as |animated|
  >
    {{#animatedIf @open duration=(orElse @growDelay 200) use=animated.verticalList}}
      {{yield @open}}
    {{/animatedIf}}
  </BvAnimated>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BvCollapsibleComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        BvCollapsible: typeof BvCollapsibleComponent;
        'bv-collapsible': typeof BvCollapsibleComponent;
    }
}
